import { useSpotlightSearch } from "@circle-react/components/Modals/SpotlightSearch";
import { useLocation } from "@tanstack/react-router";
import { useEffect } from "react";

import { readSpotlightSearchParams } from "../utils/spotlightSearchUrl";

export const useSpotlightSearchFromUrl = () => {
  const location = useLocation();
  const spotlightSearch = useSpotlightSearch();

  useEffect(() => {
    const { isOpen } = readSpotlightSearchParams(location.searchStr);
    if (isOpen && !spotlightSearch.visible) {
      void spotlightSearch.show();
    }
  }, [location.searchStr]);
};
